import { map } from "rxjs";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "rxjs/operators";
import { EntityBaseGqlService } from "../../api/EntityBaseGqlService.js";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { P2PPlayerSettingsRequestBuilder } from "./requestBuilder.js";
class P2PPlayerSettingsService extends EntityBaseGqlService {
  constructor(client, messageLocalizer) {
    const builder = new P2PPlayerSettingsRequestBuilder();
    super(client, builder, messageLocalizer);
  }
  get(requestPayload) {
    return this.fetchData(requestPayload).pipe(
      map((r) => {
        const items = r.responsePayload.getUserProfile ? [
          {
            id: r.responsePayload.getUserProfile?.uid,
            user_profile: r.responsePayload.getUserProfile,
            ...r.responsePayload.getP2PPlayerGlobalSettings && {
              global_settings: r.responsePayload.getP2PPlayerGlobalSettings
            },
            ...r.responsePayload.getP2PPlayerPersonalLimitsV2 && {
              personal_limits_v2: r.responsePayload.getP2PPlayerPersonalLimitsV2
            }
          }
        ] : [];
        return {
          ...r,
          requestPayload,
          responsePayload: {
            items,
            total: items.length
          }
        };
      })
    );
  }
  getErrorSeverity(_code) {
    return 0;
  }
}
export {
  P2PPlayerSettingsService
};
//# sourceMappingURL=service.js.map
